import checkFF from '@webapp-next/lib/feature-flag';
import { tabHighlight, showSideTeamStatusBar } from './helpers';
import {
  createWebappRoute,
  getCurrentRoute,
  getPreviousRoute,
} from '../helpers';

// TODO: to implement
/*
      {
		  		'newsfeed': 'showAllNewsfeed'
		  	,	'newsfeed/all': 'showAllNewsfeed'
		  	,	'newsfeed/mine': 'showMyNewsfeed'
		  	,	'newsfeed/important': 'showImportantNewsfeed'
		  	,	'newsfeed/location/:id': 'showNewsfeedByLocationId'
			  ,	'newsfeed/create/location/:id': 'createPostForLocation'
			  ,	'newsfeed/create/locations/:strIds': 'createPostForLocations'
		  	,	'newsfeed/create/emp/:id': 'createPostForEmp'
			  , 'newsfeed/create/emps/:strIds': 'createPostForEmps'
			  , 'newsfeed/create/all': 'createPostForAll'
		  	,	'newsfeed/create': 'createPost'
		  	,	'newsfeed/:id': 'showNewsfeedById'
			}
*/
export default [
  createWebappRoute({
    path: '/newsfeed',
    name: 'newsfeed-module',
    component() {
      const { path } = getCurrentRoute();
      console.log('ROUTER, newsfeed', path);
      tabHighlight('newsfeed');

      if (path) {
        // leave a nugget
        $dt.rtrNFGoto = path;
      }

      showSideTeamStatusBar(!checkFF('usc-442-removes-team-panels'));

      return {};
    },
  }),
  createWebappRoute({
    path: '/newsfeed/important',
    name: 'newsfeed-module-important',
    async component() {
      const { path } = getCurrentRoute();
      console.log('ROUTER, newsfeed-module-important', path);
      tabHighlight('newsfeed');

      if (path) {
        // leave a nugget
        $dt.rtrNFGoto = path;
      }

      try {
        // eslint-disable-next-line new-cap
        if (DP.utils.IsThereAModal()) {
          const { path } = getPreviousRoute();
          getRouter().replace(path);
        }
      } catch (e) {
        console.error(e);
        return;
      }
      console.log('ROUTER, newsfeed-module-important 2', path);
      window.$('a.js-desktop-global-goto-important').trigger('click');

      // // $('a.js-desktop-global-goto-important').trigger('click');
      // $dtnf.currentLocation = '';
      // $dtnf.mixFilter = { ConfirmText: 'dpRequireConfirmation' };
      // $dtnf.vwMaster.renderAll();
      //
      // if (!$dtnf.blnFfRemoveTeamPanels) {
      //   $dtw.vwTeamSidePanel.changeLocation(-1);
      // }
      //
      // $dt.featureFlags
      //   .checkPromise('ddb-152-newsfeed-workplace-list-conversion')
      //   .then(flagEnabled => {
      //     if (flagEnabled) {
      //       window.$('.js-workplace-content > li.active').removeClass('active');
      //     }
      //   });

      showSideTeamStatusBar(!checkFF('usc-442-removes-team-panels'));

      return {};
    },
  }),
  createWebappRoute({
    path: '/newsfeed/:id',
    name: 'newsfeed-module-highlight',
    component() {
      const { path, id } = getCurrentRoute();
      console.log('ROUTER, newsfeed-module-highlight', path, id);
      tabHighlight('newsfeed');

      if (path) {
        // leave a nugget
        $dt.rtrNFGoto = path;
      }

      showSideTeamStatusBar(!checkFF('usc-442-removes-team-panels'));

      return {};
    },
  }),
];
